export type FolderLink = {
  name: string;
  path: string[];
  href: string;
};

export type FolderNavigation = {
  parent: FolderLink;
  children: FolderLink[];
};

export function getFolderHref(path: string[]): string {
  return `/folder/${path.map(encodeURIComponent).join('/')}`;
}

export function normalizeFolderPath(path: string[]): string[] {
  return path.map((part) => part.trim()).filter(Boolean);
}

export function isPostInFolder(postFolders: string[], folderPath: string[]) {
  return folderPath.every((folder, index) => postFolders[index] === folder);
}

export function getFolderPathFromPathname(
  pathname: string,
  pathPrefix = '',
): string[] {
  const prefixPath = getPathname(pathPrefix).replace(/\/$/, '');
  const routePath =
    prefixPath && pathname.startsWith(`${prefixPath}/`)
      ? pathname.slice(prefixPath.length)
      : pathname;
  const marker = '/folder/';
  if (!routePath.startsWith(marker)) return [];

  return routePath
    .slice(marker.length)
    .split('/')
    .map(decodePathSegment)
    .map((part) => part.trim())
    .filter(Boolean);
}

export function getPrefixedBlogHref(pathPrefix: string, href: string): string {
  return `${pathPrefix}${href}`;
}

function getPathname(prefix: string): string {
  if (!prefix) return '';
  try {
    return new URL(prefix, 'https://quotion.local').pathname;
  } catch {
    return prefix;
  }
}

function decodePathSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

export function getFolderNavigation(
  path: string[],
  folderLinks: FolderLink[],
): FolderNavigation {
  const parentPath = path.slice(0, -1);

  return {
    parent: {
      name: parentPath.at(-1) || 'Home',
      path: parentPath,
      href: parentPath.length ? getFolderHref(parentPath) : '/',
    },
    children: folderLinks.filter(
      (folder) =>
        folder.path.length === path.length + 1 &&
        path.every((part, index) => folder.path[index] === part),
    ),
  };
}
